function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 5.77V9c0 2.115-.708 2.899-2.62 3.007a.48.48 0 01-.5-.487v-1.14c0-3.12-1.39-4.51-4.51-4.51h-1.14a.48.48 0 01-.487-.5c.108-1.912.892-2.62 3.007-2.62h3.23c2.29 0 3.02.73 3.02 3.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.63 10.38v3.24c0 2.28-.73 3.01-3.01 3.01h-3.24c-2.28 0-3.01-.73-3.01-3.01v-3.24c0-2.28.73-3.01 3.01-3.01h3.24c2.28 0 3.01.73 3.01 3.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.52 18.13a.48.48 0 01.487.5c-.108 1.912-.892 2.62-3.007 2.62H5.77c-2.29 0-3.02-.73-3.02-3.02V15c0-2.115.708-2.899 2.62-3.007a.48.48 0 01.5.487v1.14c0 3.12 1.39 4.51 4.51 4.51h1.14z"
})));